import { useParams } from 'react-router-dom'

import Topics from './Topics'
import Keywords from './Keywords'

import { type Domain } from '@pepper/utils/src/types/seo'
import { LabTab } from '../types'

type Props = {
  projectId: string
  companyId: string
  isLoadingProjectDomain: boolean
  domain?: Domain
}

const IdeaLab = ({
  companyId,
  projectId,
  domain,
  isLoadingProjectDomain,
}: Props) => {
  const { tab } = useParams<{ tab: LabTab }>()
  if (tab === 'keywords') {
    return (
      <Keywords projectId={projectId} companyId={companyId} domain={domain} />
    )
  }
  if (tab === 'topics') {
    return (
      <Topics
        projectId={projectId}
        companyId={companyId}
        domain={domain}
        isLoadingProjectDomain={isLoadingProjectDomain}
      />
    )
  }

  return null
}

export default IdeaLab
